import { DatenauswertungFormWrapper } from './DatenauswertungFormWrapper';
import { DatenauswertungGenerisch } from '../datenauswertung/DatenauswertungGenerisch';
import { DatenauswertungJahrauswahlEinzeln } from '../datenauswertung/DatenauswertungJahrauswahlEinzeln';
import { DatenauswertungReportKonfigurationBemerkungButton } from './DatenauswertungReportKonfigurationBemerkungButton';
import datenauswertungStyle from './datenauswertung.less'
import DialogWrapper2 from '../../core/dialog/dialog_wrapper_v2';
import { fn0, fn2, formatNumber } from '../../core/formatter/formatNumber';
import { getStandorte } from '../../helpers/getStandorte';
import { getStandorteGruppenTabRoutings } from '../dateneingabe/functions/StandorteGruppen';
// import { getStyle } from '../datenauswertung/generisch/DatanauswertungGenerischStyles';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { isValid as isValidFahrzeuge } from '../../main/functions/validData';
import { isVeranstaltung } from '../../helpers/getVeranstaltungen';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { StandortAuswahl } from './elements/StandortAuswahl';
import { StandorteFahrzeuge } from '../dateneingabe/detail/StandorteFahrzeuge';
import { Validierung } from './elements/Validierung';
import { ValidierungHinweise } from './elements/ValidierungHinweise';
import { WActionButton } from '../../core/elements/WActionButton';
import { WHelpIcon } from '../../core/elements/WHelpIcon';

interface DatenauswertungFahrzeugeProps extends React.ClassAttributes<any> {
    data: any;
    routing: any;
    standortTid: number;
    standortName: string;
    onRoutingChange: (routing: any) => void;
    jahr?: number;
    setJSXdirect?: (content: JSX.Element) => void;
    callbackPages?: (pageNumber: number, totalPages: number) => void;
}

interface DatenauswertungFahrzeugeState {
    pdfString?: string;
    jahr: number;
    jahrMin: number;
    jahrMax: number;
    renderButton: JSX.Element;
    validation: any;
    showFahrzeugeDlg: boolean;
}

export class DatenauswertungFahrzeuge extends
    React.Component<DatenauswertungFahrzeugeProps, DatenauswertungFahrzeugeState> {

    constructor(props: any) {
        super(props);
        const data: any = props.data || {};
        const startjahr: number = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).startjahr_datenerfassung || null;
        const jahrMax: number = new Date().getFullYear();
        let jahrMin: number = (data.first_year > 2009 && data.first_year < 2015) ? data.first_year : 2015;
        jahrMin = (startjahr > jahrMin) ? startjahr : jahrMin;
        this.state = {
            jahr: this.props.jahr || jahrMax - 1,
            jahrMin: jahrMin,
            jahrMax: jahrMax,
            renderButton: undefined,
            validation: {},
            showFahrzeugeDlg: false
        };
    }

    private entities: any[] = [
        { titel: i18n('Fahrzeuge', 'sys'), entity: IDs.ENT_FAHRZEUGE }
    ];

    componentDidMount(): void {
        this.setState({
            validation: new Validierung(
                this.props.data,
                this.props.standortTid,
                this.entities,
                'tid'
            ).getData()
        });
    }

    getValues(): any {
        const etk = this.props.data[IDs.ENT_ENERGIEDATEN_KRAFTSTOFF_ENERGIETRAEGER];
        const jahr = this.state.jahr;
        const rows: any[] = [];
        const diag1: any[] = [];
        const diag2: any[] = [];
        const custom_row_classes: any[] = [];
        const row_web_forced: boolean[] = [];
        const fahrzeuge: any[] = this.props.data[IDs.ENT_FAHRZEUGE] || [];
        const kraftstoffe: any[] = this.props.data[IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE].filter((k: any) => k.jahr === jahr) || [];
        // const fahrzeuge_jahreswerte: any[] = (this.props.data[IDs.ENT_FAHRZEUGE_JAHRESWERTE] || [])
        //     .filter((fahrzeug: any ) => isValidFahrzeuge(fahrzeug, IDs.ENT_FAHRZEUGE_JAHRESWERTE));
        // console.log('F', fahrzeuge, kraftstoffe);
        let cnt = 0;
        fahrzeuge
            .filter((fahrzeug: any) =>
                (!this.props.standortTid || fahrzeug.standort_tid_orig === this.props.standortTid)
                && (
                    (fahrzeug.status || null) !== 2 || ((fahrzeug.status || null) === 2 && typeof fahrzeug.jahr_status === 'number'
                        && fahrzeug.jahr_status >= jahr)
                )
            )
            .forEach((fahrzeug: any) => {
                const alter = fahrzeug.baujahr && fahrzeug.baujahr > 0 ? jahr - fahrzeug.baujahr : -1;
                const energietraeger = fahrzeug.energiedaten_kraftstoff_energietraeger;
                const isValid: boolean = isValidFahrzeuge(fahrzeug, IDs.ENT_FAHRZEUGE);
                const leistung = fahrzeug.leistung;
                const standort = fahrzeug.standort_tid;
                const werte = fahrzeug || {};
                // const werte = fahrzeuge_jahreswerte.find((fjw: any) => fjw.fahrzeug_tid_orig === fahrzeug.tid && jahr === fjw.jahr)
                //    || fahrzeug || {};
                // const verbrauch = werte ? (werte.auslastungsfaktor / 100) * werte.betriebszeit_h_tag * werte.betriebszeit_tage_jahr : 0;
                if (!isValid && !this.state.validation[fahrzeug.tid]) {
                    return;
                }
                let laufleistung = 0;
                let verbrauch = 0;
                let et: any = null;
                kraftstoffe
                    .filter((k: any) => k.fahrzeug_tid_orig === fahrzeug.tid)
                    .forEach((k: any) => {
                        laufleistung += (k.laufleistung || 0);
                        verbrauch += (k.verbrauch || 0);
                        et = etk.find((e: any) => e.tid === k.energietraeger_tid_orig);
                    });
                const verbrauch_100 = (laufleistung > 0 && verbrauch > 0) ? ((verbrauch / laufleistung) * 100) : null;
                cnt += isValid ? 1 : 0;
                const row = [
                    cnt,
                    standort,
                    fahrzeug.name,
                    fahrzeug.fahrzeug_typ_tid,
                    alter < 0
                        ? '-'
                        : (alter === 0
                            ? `< 1 ${i18n('Jahr', 'sys')}`
                            : (alter === 1 ? `1 ${i18n('Jahr', 'sys')}` : `${alter} ${i18n('Jahre', 'sys')}`)
                        ),
                    leistung > 0 ? `${formatNumber(leistung, 2)} kW` : '-',
                    energietraeger,
                    laufleistung > 0 ? fn0(laufleistung) + ' km' : '-',
                    verbrauch > 0 ? fn0(verbrauch) + ' ' + (et ? et.einheit_tid : '') : '-',
                    verbrauch_100 > 0 ? fn2(verbrauch_100) + ' ' + (et ? et.einheit_tid : '') : '-'
                ];
                if (this.props.standortTid) {
                    row.splice(1, 1);
                }
                const row_length: number = row.length;
                const isWebForced: boolean = !!(!isValid && this.state.validation[fahrzeug.tid]);
                rows.push(
                    [
                        <div data-text={isValid ? row[0] : ' '}>
                            <div>{isValid ? row[0] : <>&nbsp;</>}</div>
                            {this.state.validation[fahrzeug.tid] &&
                                <ValidierungHinweise
                                    entities={this.entities}
                                    id={fahrzeug.tid}
                                    showPriorityColors
                                    validation={this.state.validation}
                                />
                            }
                        </div>,
                        ...[...Array(row_length - 1)].map((item: any, index: number) => row[index + 1])
                    ]
                );
                custom_row_classes.push(isWebForced ? Array.from(Array(row_length), () => 'row_field') : undefined);
                row_web_forced.push(isWebForced);
            });
        return { rows, diag1, diag2, custom_row_classes, row_web_forced };
    }

    render(): JSX.Element {
        // const lineColor = ['#4f81bd', '#f79646', '#87bd51', '#51bd75', '#5163bd', '#9951bd', '#bd5175', '#bd5151'];
        // const style: any = { sub: getStyle('sub') };
        // const totalWidth = 13 * 60; // Das war die Ausgangsbasis
        const numCols = 9.5 + (this.props.standortTid ? 0 : 1.5);
        const baseWidth = 100 / numCols; // Bitte immer in Prozent angeben
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || null;
        const values = this.getValues();
        const config: any = {
            titel0: unternehmen,
            titel1: `Zusammenstellung Fahrzeuge ${this.state.jahr}`,
            titel2: this.props.standortName,
            filename: `Zusammenstellung_Fahrzeuge_${this.state.jahr}.pdf`,
            report: { data: (this.props.data || {})[IDs.ENT_REPORT] || [], standort: +this.props.standortTid || 0, key: 'fahrzeuge' },
            baseWidth: baseWidth,
            header: {
                blocks: [
                    {
                        label: i18n('Stammdaten', 'sys'),
                        width: `${baseWidth * (6 + (this.props.standortTid ? 0 : 1.5))}%`,
                        columns: [
                            { label: i18n('Nr', 'sys'), customStyleLabel: { fontSize: 8 }, customStyleColumn: { flexGrow: '0.5' } },
                            { label: i18n('Standort', 'sys'), customStyleColumn: { flexGrow: '1.5', paddingRight: '1pt' } },
                            { label: i18n('Fahrzeug / Bezeichnung', 'sys'), customStyleColumn: { flexGrow: '1.5' } },
                            { label: i18n('Typ', 'sys') },
                            { label: i18n('Alter', 'sys') },
                            { label: i18n('Nennleistung', 'sys') },
                            { label: i18n('Kraftstoff', 'sys') }
                        ]
                    },
                    {
                        label: i18n('Jährliche Leistungsdaten', 'sys'),
                        width: `${baseWidth * 3.5}%`,
                        columns: [
                            { label: i18n('Jahreslaufleistung', 'sys') },
                            { label: i18n('Kraftstoffverbrauch/Jahr', 'sys'), customStyleColumn: { flexGrow: '1.5' } },
                            { label: `${i18n('Verbrauch pro', 'sys')} 100 km` }
                        ]
                    }
                ]
            },
            rows: values.rows,
            row_classes: ['row_field_header'],
            custom_row_classes: values.custom_row_classes,
            row_web_forced: values.row_web_forced,
            rows_width: [baseWidth * 0.5, baseWidth * 1.5, baseWidth * 1.5, baseWidth, baseWidth, baseWidth, baseWidth, baseWidth, baseWidth * 1.5, baseWidth],
            diagrams: []
        };
        if (this.props.standortTid) {
            config.header.blocks[0].columns.splice(1, 1);
            config.rows_width.splice(1, 1);
        }
        const helpIcon = (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ display: 'inline-block' }}
                styleProps={{ width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0 }}
                label={i18n('Datenauswertung - Hinweise', 'sys')}
                helpKey='datenauswertung_fahrzeuge'
                type='info'
                editBar
            />
        );

        const arr_header_form_elements: any[] = [
            {
                elem: <DatenauswertungJahrauswahlEinzeln
                    jahrMax={this.state.jahrMax}
                    jahrMin={this.state.jahrMin}
                    jahr={this.state.jahr}
                    onJahrChange={(jahr: number) => this.setState({ jahr: +jahr })}
                    renderClean={true}
                />,
                wrapClass: 'datenauswertungContentLeft'
            },
            {   elem: isVeranstaltung(this.props.data, this.props.standortTid) ? this.renderVeranstaltung() : this.renderStandort(),
                wrapClass: 'datenauswertungContentGrow'
            },
            { elem: <span className={datenauswertungStyle.datenauswertungArrow}>🡆</span>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>{i18n('Optionen', 'sys')}</label>{this.renderEingabeButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.renderBemerkungButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.state.renderButton}</>, wrapClass: 'datenauswertungContentRight' },
            // {elem: <><label>&nbsp;</label><div style={{ padding: 5, paddingRight: 20 }}>{helpIcon}</div></>, wrapClass: 'datenauswertungContentRight'}
        ];

        return (
            <div>
                {!this.props.setJSXdirect &&
                    <div className={datenauswertungStyle.datenauswertungOuterFormContainer}>
                        {/*<DatenauswertungJahrauswahlEinzeln
                            jahrMax={this.state.jahrMax}
                            jahrMin={this.state.jahrMin}
                            jahr={this.state.jahr}
                            externalHeaderElements={[this.renderEingabeButton(), this.renderBemerkungButton(), this.state.renderButton]}
                            onJahrChange={(jahr: number) => this.setState({ jahr: +jahr })}
                        />
                        <div style={{ padding: 5, paddingRight: 20 }}>{helpIcon}</div>
                        */}
                        <DatenauswertungFormWrapper
                            elements={arr_header_form_elements}
                        />
                    </div>
                }
                <DatenauswertungGenerisch
                    config={config}
                    orientation='landscape'
                    setRenderButton={(renderButton: JSX.Element) => this.setState({ renderButton })}
                    setJSXdirect={this.props.setJSXdirect}
                    callbackPages={typeof this.props.callbackPages === 'function' ? this.props.callbackPages : null}
                    pdfButtonStyle={{ backgroundColor: '#686868', color: '#fff' }}
                />
                {this.state.showFahrzeugeDlg && this.renderFahrzeugeDlg()}
            </div>
        );
    }

    renderBemerkungButton(): JSX.Element {
        return (
            <DatenauswertungReportKonfigurationBemerkungButton
                data={this.props.data}
                standort={this.props.standortTid}
                type='fahrzeuge'
                styleProps={{ backgroundColor: '#686868', color: '#fff' }}
                noLabel={true}
            />
        );
    }

    renderEingabeButton(): JSX.Element {
        const data: any = this.props.data || {};
        const isGefuehrterModus: boolean = (data[IDs.ENT_KONFIGURATION] || [])
            .some((param: any) => param.gefuehrter_modus_orig === 1);
        const standorte: any[] = (getStandorte(data) || []).map((standort: any) => standort.tid);
        const index: number = standorte.indexOf(this.props.standortTid);
        const path: any = isGefuehrterModus
            ? RoutingIDs.ROUTE_DATENEINGABE
            : {
                ...RoutingIDs.ROUTE_DATENEINGABE_FAHRZEUGE,
                [RoutingIDs.TABS_DATENEINGABE_FAHRZEUGE]: index === -1 ? 0 : index,
                terminateOn: RoutingIDs.TABS_DATENEINGABE_FAHRZEUGE
            };
        const konfig = (this.props.data[IDs.ENT_KONFIGURATION] || [])[0];
        return (
            <WActionButton
                label={i18n('Dateneingabe', 'sys')}
                insideText={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                tooltip={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                key='dateneingabe'
                action='editNote'
                styleProps={{ backgroundColor: '#728A49', color: '#fff' }}
                onAction={() => {
                    if (konfig && (konfig.gefuehrter_modus === 'Ja' || konfig.gefuehrter_modus === 1)) {
                        this.setState({ showFahrzeugeDlg: true });
                    } else {
                        this.props.onRoutingChange({ path })
                    }
                }}
            />
        );
    }

    renderFahrzeugeDlg() {
        const { data, standortTid } = this.props;
        let standort;
        if (standortTid > 0) {
            standort = (data[IDs.ENT_STANDORT] || []).find((s: any) => s.tid === standortTid);
        }
        return <div>
            <DialogWrapper2
                title={`${i18n('Dateneingabe', 'sys')}: ${i18n('Fahrzeuge', 'sys')}`}
                width={-1}
                onAfterClose={() => this.setState({ showFahrzeugeDlg: false })}
            >
                <div style={{ maxWidth: window.innerWidth - 60, overflow: 'auto' }}>
                    <StandorteFahrzeuge
                        data={data}
                        onRoutingChange={() => { }}
                        routing={{}}
                        standortSelected={standort}
                    />
                </div>
            </DialogWrapper2>
        </div>;
    }

    renderStandort(): JSX.Element {
        const disabled: boolean = this.props.data.MODUL_SELECTED === 'steuer';

        return (
            <StandortAuswahl
                label={i18n('Standort', 'sys')}
                data={this.props.data}
                standort={this.props.standortTid}
                disabled={disabled}
                filter={(standort: any, callback: (visible: boolean) => void) => {
                    const kennzahlen: any = (this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort.tid]
                        || this.props.data[IDs.KENNZIFFERN_BERECHNET] || {};
                    const flags: any = kennzahlen.flags || {};

                    if (typeof callback === 'function') {
                        callback(!!flags.hasFahrzeuge);
                    }
                }}
                onStandortChange={(standort: number) => {
                    const basisRouting: any = RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE;
                    const basisTab: string = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
                    const tabRoutings: any[] = getStandorteGruppenTabRoutings(this.props.data, basisRouting, basisTab, 2);
                    const path: any = (tabRoutings.find((item: any) => item?.dataRow?.tid === standort) || {}).path || {};
                    this.props.onRoutingChange({ path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_FAHRZEUGE, ...path } });
                }}
                renderClean
            />
        );
    }

    renderVeranstaltung(): JSX.Element {
        return <>
            <label>{i18n('Standort', 'sys')}</label>
            <input type='text' value={this.props.standortName} disabled />
        </>;
    }
}
